var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{style:({ 'background-image': 'url(' + _vm.step.img + ')' })},[_c('div',{staticClass:"stepId"},[_vm._v(_vm._s(_vm.step.id))]),_c('h2',[_vm._v(_vm._s(_vm.step.title))]),_c('p',[_vm._v(_vm._s(_vm.step.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }